import { render } from "./RegisterCard.vue?vue&type=template&id=8f631fb6&ts=true"
import script from "./RegisterCard.vue?vue&type=script&lang=ts"
export * from "./RegisterCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__